import { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaWhatsapp } from "react-icons/fa";
import PageHeader from "../components/PageHeader";
import SectionTitle from "../components/SectionTitle";
import { siteConfig } from "../data/siteConfig";
import "../styles/Pages.css";
import "../styles/Contact.css";

const Contact = () => {
  useEffect(() => { document.title = "Contact Us | USHA Resort, Patna"; }, []);

  const emptyForm = { name: "", email: "", phone: "", subject: "Stay Enquiry", message: "" };
  const [form, setForm] = useState(emptyForm);
  const [sent, setSent] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const text =
      `New Contact Enquiry – USHA Resort\n\n` +
      `Name: ${form.name}\nPhone: ${form.phone}\nEmail: ${form.email || "-"}\n` +
      `Subject: ${form.subject}\nMessage: ${form.message}`;

    window.open(`https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent(text)}`, "_blank");
    setSent(true);
    setForm(emptyForm);
  };

  const info = [
    { icon: FaMapMarkerAlt, title: "Our Address", lines: [siteConfig.address] },
    { icon: FaPhoneAlt, title: "Phone / WhatsApp", lines: [siteConfig.phone], link: siteConfig.phoneHref },
    { icon: FaEnvelope, title: "Email", lines: [siteConfig.email], link: `mailto:${siteConfig.email}` },
    { icon: FaClock, title: "Opening Hours", lines: [siteConfig.hours] },
  ];

  return (
    <>
      <PageHeader
        title="Get In Touch"
        subtitle="Home · Contact"
        image="/images/contactus/2.png"
      />

      <section>
        <div className="container">
          <SectionTitle
            tag="Contact Us"
            title="We'd Love to Hear From You"
            subtitle="Call, WhatsApp or drop us a message — our team replies quickly."
          />

          <div className="contact-grid gap-top">
            {/* Info cards */}
            <div className="contact-info">
              {info.map(({ icon: Icon, title, lines, link }) => (
                <div className="contact-card" key={title}>
                  <div className="cc-icon"><Icon /></div>
                  <div>
                    <h4>{title}</h4>
                    {link ? (
                      <a href={link}>{lines[0]}</a>
                    ) : (
                      lines.map((l) => <p key={l}>{l}</p>)
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Form */}
            <form className="contact-form-card" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="Your name" required />
                </div>
                <div className="form-group">
                  <label>Phone Number *</label>
                  <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="+91 ..." required />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
                </div>
                <div className="form-group">
                  <label>Subject</label>
                  <select name="subject" value={form.subject} onChange={handleChange}>
                    <option>Stay Enquiry</option>
                    <option>Wedding / Banquet</option>
                    <option>Pool Party / Day Outing</option>
                    <option>Corporate Event</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className="form-group full">
                  <label>Message *</label>
                  <textarea name="message" value={form.message} onChange={handleChange} placeholder="Write your message..." required />
                </div>

                {sent && <div className="form-success">✅ Thank you! WhatsApp should have opened — just press Send.</div>}

                <button type="submit" className="btn btn-gold booking-submit">
                  <FaWhatsapp /> Send Message
                </button>
              </div>
            </form>
          </div>

          {/* Map */}
          <div className="map-wrap">
            <iframe
              title="USHA Resort Location Map"
              src="https://maps.google.com/maps?q=Usha%20Resort%20Patna&t=&z=14&ie=UTF8&iwloc=&output=embed"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;